export const E2E_USER_AGENT = 'MrFatUserAgent'
